VLW.ListeEquipe = class extends VLW.classBase {
	constructor(elt) {
		super(elt);
		this.listeSmartphone = document.querySelector(".listeEquipe");
		this.listeBureau     = this.listeSmartphone.cloneNode(true);
		document.body.appendChild(this.listeBureau);
		broadCaster.MENU_HOVER.add(this.onMenuHover);
		broadCaster.MENU_LEAVE.add(this.onMenuLeave);
		broadCaster.INTROPAGE.add(this.onMainIntroOK);
		this.scrollBar = new VLW.scrollBar(this.listeBureau.querySelector(".vlwScroll"));
		CONFIG.INTRO_DONE === true && this.introContent(.5);
		site.events.onLoadStart.add(this.outro);
		[...this.listeSmartphone.querySelectorAll("[data-style-background-src]"), ...this.listeBureau.querySelectorAll("[data-style-background-src]")].forEach((elt) => {
			const src = elt.dataset.styleBackgroundSrc;
			(new Promise((resolve, reject) => {
				const image  = new Image();
				image.onload = resolve;
				image.src    = src;
			})).then(() => {
				elt.classList.add("_backgroundImageLoaded");
				elt.style.backgroundImage = `url(${src})`;
			});
		});
	}
	
	onMainIntroOK() {
		this.introContent(1.5);
	}
	
	introContent(delay = 0) {
		let tl = new TimelineMax({delay});
		tl.to(this.listeBureau, .5, {opacity: 1});
		tl.staggerFromTo(this.listeBureau.querySelectorAll("li"), .8, {opacity: 0}, {opacity: 1, ease: Sine.easeIn}, .3, 0);
	}
	
	onMenuHover() {
		TweenMax.to(this.listeBureau, .5, {opacity: 0})
	};
	
	onMenuLeave() {
		TweenMax.to(this.listeBureau, .5, {opacity: 1})
	}
	
	outro() {
		TweenMax.killTweensOf(this.listeBureau);
		TweenMax.killTweensOf(this.listeSmartphone);
		TweenMax.to(this.listeBureau	, .7, {opacity: 0});
		TweenMax.to(this.listeSmartphone, .7, {opacity: 0});
	}
	
	instanceClean() {
		removeNode(this.listeBureau);
		this.scrollBar.instanceClean();
		site.events.onLoadStart.remove(this.outro);
		broadCaster.INTROPAGE.remove(this.onMainIntroOK);
		broadCaster.MENU_HOVER.remove(this.onMenuHover);
		broadCaster.MENU_LEAVE.remove(this.onMenuLeave);
		super.instanceClean();
	}
};